<!-- Goftino -->
<!-- <script src="https://www.goftino.com/widget/bt3Bfu" defer></script> -->

<!-- <app-cat-loading></app-cat-loading> -->

<!-- swiper examples -->
<!-- https://stackblitz.com/edit/swiper-angular-example?file=src%2Fapp%2Fapp.component.ts,src%2Fapp%2Fapp.component.html -->

<div class="home-box">
    <div class="right">
        <swiper [pagination]="true" [autoplay]="{ delay: 5000, disableOnInteraction: false }" [allowTouchMove]="true"
            class="slider-parent">
            <ng-template swiperSlide data-swiper-autoplay="5000" *ngFor="let baner of banners" matRipple>
                <ngx-skeleton-loader [theme]="{height: '100%', borderRadius: '0', width:'100%'}" appearance="line"
                    *ngIf="loader">
                </ngx-skeleton-loader>
                <div class="img-wrapper" *ngIf="!loader">
                    <a [href]="baner.link_data_5?.url" target="_blank">
                        <img class="slider" [src]="baner.image_url" alt="Carousel Image" loading="lazy" />
                    </a>
                </div>
            </ng-template>
        </swiper>
        <div class="main-xs">
            <div class="home-banner_container">
                <div class="home-router-thumnail">
                    <img matRipple (click)="onOpenCourseListBottomSheet()"
                        [src]="'../../../../../assets/new/Home_Banner/02.webp'" alt="" class="home-banner"
                        loading="lazy" *ngIf="!loader" />
                    <ngx-skeleton-loader *ngIf="loader" [theme]="{height: '100%', borderRadius: '1rem', width:'100%'}"
                        appearance="line">
                    </ngx-skeleton-loader>
                </div>
                <div class="home-router-thumnail">
                    <img (click)="onGoToPracticeExam()" matRipple
                        [src]="'../../../../../assets/new/Home_Banner/03.webp'" alt="" class="home-banner"
                        loading="lazy" *ngIf="!loader" />
                    <ngx-skeleton-loader *ngIf="loader" [theme]="{height: '100%', borderRadius: '1rem', width:'100%'}"
                        appearance="line">
                    </ngx-skeleton-loader>
                </div>
                <div class="home-router-thumnail">
                    <img (click)="onGoToTests()" src="../../../../../../assets/new/Home_Banner/بانک تست.webp"
                        class="banner home-banner" alt="" loading="lazy" *ngIf="!loader" />

                    <ngx-skeleton-loader *ngIf="loader" [theme]="{height: '100%', borderRadius: '1rem', width:'100%'}"
                        appearance="line">
                    </ngx-skeleton-loader>
                </div>
                <div class="home-router-thumnail">
                    <img matRipple [routerLink]="['/blog-list']" [src]="'../../../../../assets/new/Home_Banner/04.webp'"
                        alt="" class="home-banner" loading="lazy" *ngIf="!loader" />
                    <ngx-skeleton-loader *ngIf="loader" [theme]="{height: '100%', borderRadius: '1rem', width:'100%'}"
                        appearance="line">
                    </ngx-skeleton-loader>
                </div>
            </div>
            <div class="dashed-title card-customize mt05">
                <h2>
                    <img class=" " src="../../../../../assets/icons/free-course2.svg">
                    <span>
                        دوره‌های رایگان تیک
                    </span>
                </h2>
            </div>
            <div class="divider05"></div>
            <div class="freeCourse ">
                <div class="card-items">
                    <div (click)="onGoToFreeCourse(item)" #freeCourse class="card-item card-style free-course"
                        *ngFor="let item of mainFreeCourse">
                        <ngx-skeleton-loader *ngIf="freeCourseLoader"
                            [theme]="{height:'100%', borderRadius: '0', width:'100%'}" appearance="line">
                        </ngx-skeleton-loader>
                        <img *ngIf="!freeCourseLoader" [src]="item?.ThumbImageFile" loading="lazy">
                    </div>

                </div>
            </div>
            <div *ngIf="showMobile" class="divider05"></div>
            <div *ngIf="showMobile" class="dashed-title card-customize mt05">
                <img class="" loading="lazy" src="../../../../../assets/icons/news2.svg">
                <h2>اخبار </h2>
            </div>
            <div *ngIf="showMobile" class="divider05"></div>
            <div *ngIf="showMobile" class="news-items  scrolly-max-350">
                <div class="news-item" *ngFor="let item of blogList">
                    <ngx-skeleton-loader *ngIf="loadingBlogList"
                        [theme]="{height:'30px', borderRadius: '0', width:'100vw'}" appearance="line">
                    </ngx-skeleton-loader>
                    <!-- <span *ngIf="!loadingBlogList" class="icon-news">*</span> -->
                    <div (click)="onGoToBlogDetail(item?.Id)" *ngIf="!loadingBlogList" class="news-content-wrapper"
                        style="display: flex; flex-direction:  row;">
                        <div class="img-item-container">
                            <img class="img-item" [src]="item?.ThumbImageFile">
                        </div>
                        <a class="news-item-title" *ngIf="!loadingBlogList">{{item?.Title | farsiNumber}} </a>
                    </div>

                    <div *ngIf="!loadingBlogList" class="font-light-gray news-time">{{item?.UnixRecordDate | timeAgo
                        | farsiNumber}}</div>


                </div>
            </div>
            <div class="divider05"></div>
            <div class="dashed-title card-customize mt05">
                <img class="" src="../../../../../assets/icons/top-content2.svg" loading="lazy">
                <h2>محتواهای برتر </h2>
            </div>
            <div class="divider05"></div>

            <app-swiper [items]="topContent" [title]="" [Loading]="topContentLoader"
                (onClickItem)="handleTopContentClick($event)"></app-swiper>
            <div *ngIf="showMobile" class="divider05"></div>
        </div>
    </div>
    <div class="left" *ngIf="!showMobile">
        <div *ngIf="!showMobile" class="dashed-title mb05">
            <img class="" src="../../../../../assets/icons/news2.svg" loading="lazy">
            <h2> اخبار </h2>
        </div>
        <div class="news-items scrolly-max-350">
            <div class="news-item" *ngFor="let item of blogList">
                <ngx-skeleton-loader *ngIf="loadingBlogList" [theme]="{height:'30px', borderRadius: '0', width:'100vw'}"
                    appearance="line">
                </ngx-skeleton-loader>

                <div (click)="onGoToBlogDetail(item?.Id)" *ngIf="!loadingBlogList" class="news-content-wrapper"
                    style="display: flex; flex-direction:  row;">
                    <div class="img-item-container">
                        <img class="img-item" [src]="item?.ThumbImageFile">
                    </div>
                    <a class="news-item-title" *ngIf="!loadingBlogList">{{item?.Title | farsiNumber}} </a>
                </div>

                <div *ngIf="!loadingBlogList" class="font-light-gray news-time">{{item?.UnixRecordDate | timeAgo
                    | farsiNumber}}</div>
            </div>

        </div>
        <div *ngIf="!showMobile" class="divider05"></div>
        <div *ngIf="!showMobile" class="hero-board sticky">
            <div class="top-items" style="max-height: 5rem;">
                <mat-select class="form-field-box"
                    [placeholder]="leaderBoards?.length? leaderBoards[0].title:'انتخاب کنید'">
                    <mat-option class="mat-op-value" *ngFor="let board of leaderBoards"
                        (click)="getLeaderBoardDetail(board.id)" [value]="board.title">
                        {{ board.title }}
                    </mat-option>
                </mat-select>
                <div fxLayout="row" fxLayoutAlign="start center">
                    <img src="../../../../../assets/new/Board.webp" loading="lazy" alt="">
                </div>
            </div>
            <div class="heros scrolly-max-350">
                <div class="hero" *ngFor="let hero of heros">
                    <div class="righthero">
                        <ngx-skeleton-loader appearance="circle" *ngIf="leaderboardloader"></ngx-skeleton-loader>
                        <ngx-skeleton-loader [count]="1" appearance="line"
                            [theme]="{display: 'block',height: '10px', width: '100px'}"
                            *ngIf="leaderboardloader"></ngx-skeleton-loader>

                        <div class="person" *ngIf="!leaderboardloader">
                            <span class="order" *ngIf="hero.order > 3">{{hero.order}}</span>
                            <img src="../../../../../assets/icons/MedalGolden.svg" *ngIf="hero.order == 1"
                                class="icon-height-menu" loading="lazy">
                            <img src="../../../../../assets/icons/MedalSilver.svg" *ngIf="hero.order == 2"
                                class="icon-height-menu" loading="lazy">
                            <img src="../../../../../assets/icons/MedalBronze.svg" *ngIf="hero.order == 3"
                                class="icon-height-menu" loading="lazy">

                            <img class="hero-avatar "
                                [src]="hero.student_pic ? hero.student_pic : '../../../../../assets/new/avatar-def.png'"
                                loading="lazy" />
                            <div class="about">
                                <app-text-animate *ngIf="!loader" [textValue]="hero.student_fullname"
                                    [textSize]="'11pt'" [textWeight]="'900'">
                                </app-text-animate>
                                <div class="months-tik">
                                    <p>{{hero.student_register_time | dayTimer | farsiNumber }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="result">
                        <ngx-skeleton-loader appearance="line" *ngIf="leaderboardloader"
                            [theme]="{height: '15px', width: '100px'}"></ngx-skeleton-loader>
                        <p *ngIf="!leaderboardloader">{{hero.description}}</p>
                        <img src="../../../../../assets/icons/Target.svg" class="icon-height-little"
                            *ngIf="!leaderboardloader" loading="lazy">
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="!showMobile" class="divider05"></div>
    </div>


</div>